import type { ProductsSearch } from '../model/search-params';

// Maps the URL `visibility` filter to the `withHidden` query flag:
//   'visible' → false (hide hidden products)
//   'hidden'  → true  (show only hidden — legacy "hidden" view)
//   undefined → undefined ("All Products", legacy default)
// Shared by the products table + map so both interpret visibility the same.
export const visibilityToWithHidden = (
  visibility: ProductsSearch['visibility']
): boolean | undefined => {
  if (visibility === 'visible') return false;
  if (visibility === 'hidden') return true;
  return undefined;
};
